import React, {Component, useState} from 'react';

import {
    ButtonSet, Button
} from "carbon-components-react";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";

export default class extends Component {

    state = {
        form: {
            modal_delete: false,
            id: "",
            user: ""
        }
    };

    constructor(props) {
        super(props);
        //this.handleChange = this.handleChange.bind(this);

    }

    componentDidMount() {
        let {form} = this.props;
        this.setState({
            form: {
                modal_delete: form.modal_delete,
                user: form.user,
                id: form.id,
            }
        })
    }

    handleSubmit = async (e) => {
        this.props.onSubmitForm(this.state.form);
    }

    handleCloseModal = async (e) => {
        this.setState(prevState => ({
            form: {...prevState.form, modal_delete: false}
        }));
        this.props.onCloseModal(this.state.form);
    }


    handleChange = e => {
        e.preventDefault();
        const {name, value} = e.target;
        this.setState(prevState => ({
            form: {...prevState.form, [name]: value}
        }));
    };

    render() {

        return (
            <>
                <Dialog open={this.state.form.modal_delete} onClose={(e) => this.handleCloseModal(e)}
                        aria-labelledby="form-dialog-title"
                        fullWidth={true}>
                    <DialogTitle id="form-dialog-title"><span
                        style={{color: "#000"}}>Deletar usuário</span>
                    </DialogTitle>
                    <DialogContent style={{paddingBottom: "50px"}}>
                            <p>Tem certeza que deseja apagar o usuário: <span style={{fontWeight: "900"}}>{this.state.form.user}</span></p>
                            <p>Essa ação o removerá por completo da plataforma.</p>
                    </DialogContent>
                    <DialogActions style={{padding: "0px"}}>
                        <div style={{width: "100%"}}>
                            <Button style={{width: "50%"}} kind="secondary" onClick={(e) => this.handleCloseModal(e)} isExpressive>
                               Cancelar
                            </Button>
                            <Button style={{width: "50%"}} kind="danger" onClick={(e) => this.handleSubmit(e)} isExpressive>
                                Deletar
                            </Button>
                        </div>
                    </DialogActions>
                </Dialog>
            </>
        );
    }
}
